import { render } from "./OverallTrackingHistory.vue?vue&type=template&id=54029558"
import script from "./OverallTrackingHistory.vue?vue&type=script&lang=js"
export * from "./OverallTrackingHistory.vue?vue&type=script&lang=js"

import "./OverallTrackingHistory.vue?vue&type=style&index=0&id=54029558&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__